import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ErrorMessageHelper } from '../utilities/error-message.i18n.helper';

@Injectable({ providedIn: 'root' })
export class PhoneI18nValidator {
    constructor(public errorMessageHelper: ErrorMessageHelper) {}

    public phone(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value && control.value.length !== 10) {
                return {
                    exactLength: { message: this.errorMessageHelper.exactLength(10) }
                };
            }

            return null;
        };
    }
}
